import { createSlice } from '@reduxjs/toolkit'

export const toastSlice = createSlice({
  name: 'toast',
  initialState: {
    toast: {
      open: false,
      message: '',
    },
  },
  reducers: {
    setToast: (state, action) => {
      state.toast = {
        open: action.payload.open,
        message: action.payload.message,
      }
    },
  },
})

export const selectToastSetting = (state) => state.toast

export const { setToast } = toastSlice.actions

export default toastSlice.reducer
